<template>
  <div class="app-main-content">
    <div>
      <h1>Contact Information</h1>
      <div><SystemAlert/></div>
      <ContactUpdate v-if="store.state.guestLogin.contactUpdateStep == 1" />
      <ContactInformation v-if="store.state.guestLogin.contactUpdateStep == 2" />
      <ContactValidate v-if="store.state.guestLogin.contactUpdateStep == 3" />
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';

import ContactUpdate from '../../components/updateContacts/ContactUpdate.vue';
import ContactInformation from '../../components/updateContacts/ContactInformation.vue';
import ContactValidate from '../../components/updateContacts/ContactValidate.vue';
import SystemAlert from '@/components/SystemAlert';

// Vuex store
const store = useStore();

// Clear the step in the store when the component is unmounted lifecycle hook
onBeforeUnmount(() => {
  store.state.guestLogin.contactUpdateStep = 1;
});
</script>